<template>
  <v-container>
    <v-container class="px-5 elevation-2" v-if="deck">
      <v-row class="mt-3" align="center">
        <h1>{{deck.title}}</h1>
        <v-spacer></v-spacer>

        <a :href="shareUrl" rel="nofollow" target="_blank">Twitterでシェアする</a>

        <v-btn color="primary" @click="forkDeck()" :loading="forkLoading" class="ml-5">
          <v-icon>mdi-pencil</v-icon>このデッキをコピーして新しく作る
        </v-btn>
      </v-row>
      <p class="mt-5">{{deck.description}}</p>
    </v-container>

    <v-container class="mt-5 px-5 elevation-2" v-if="deck">
      <v-row class="mt-3" align="center">
        <v-btn color="primary" @click="randomPick()" :loading="loadingPick">
          <v-icon>mdi-pencil</v-icon>このデッキからランダムにカードを引く
        </v-btn>
      </v-row>

      <v-dialog v-model="pickDialog" max-width="720">
        <v-card>
          <v-card-title class="headline">現在のカード</v-card-title>

          <v-container>
            <KaiwaCardItem :card="currentPickedCard" v-if="currentPickedCard" />
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary darken-1" text @click="pickDialog = false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <CardList :cards="cards" />
  </v-container>
</template>


<script>
// @ is an alias to /src

import { mapGetters } from "vuex";
import router from "@/router";
import CardList from "@/components/CardList.vue";
import KaiwaCardItem from "@/components/KaiwaCardItem.vue";

export default {
  name: "DeckDetail",
  components: {
    CardList,
    KaiwaCardItem,
  },
  computed: {
    ...mapGetters("deckDetail", {
      loading: "getLoading",
      deck: "getDeck",
      cards: "getCards",
      currentPickedCard: "currentPickedCard",
      loadingCards: "getLoadingCards",
      loadingPick: "getLoadingPick",
    }),
    ...mapGetters("draftDeck", {
      forkLoading: "loading",
    }),
    shareUrl() {
      return `https://twitter.com/intent/tweet?text=会話デッキ「${this.deck.title}」を作成しました%0a&url=https://kaiwadeck.com/decks/${this.deck.deckId}&hashtags=会話デッキメーカー`;
    },
  },
  data: () => ({
    pickDialog: false,
  }),
  watch: {
    $route(to, from) {
      if (!this.$route.params["deckId"]) {
        return;
      }
      this.$store.dispatch("deckDetail/fetchDeck", {
        deckId: this.$route.params["deckId"],
      });
      this.$store.dispatch("deckDetail/fetchCards", {
        deckId: this.$route.params["deckId"],
      });
    },
  },
  mounted() {
    this.$store.dispatch("deckDetail/fetchDeck", {
      deckId: this.$route.params["deckId"],
    });
    this.$store.dispatch("deckDetail/fetchCards", {
      deckId: this.$route.params["deckId"],
    });
  },
  methods: {
    forkDeck() {
      this.$store.dispatch("draftDeck/forkDeck", {
        deck: this.deck,
        cards: this.cards,
      });
    },
    randomPick() {
      this.pickDialog = true;
      this.$store.dispatch("deckDetail/randomPick", {
        cards: this.cards,
      });
    },
  },
};
</script>
